"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslitFooterPill = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const Iconista_1 = require("@jsonjoy.com/ui/lib/icons/Iconista");
const context_1 = require("../context");
const BasicTooltip_1 = require("@jsonjoy.com/ui/lib/4-card/BasicTooltip");
const BasicButton_1 = tslib_1.__importDefault(require("@jsonjoy.com/ui/lib/2-inline-block/BasicButton"));
const keys_1 = require("../util/keys");
const Separator_1 = require("@jsonjoy.com/ui/lib/3-list-item/Separator");
const Space_1 = require("@jsonjoy.com/ui/lib/3-list-item/Space");
const wrapClass = (0, nano_theme_1.rule)({
    d: 'inline-flex',
    ai: 'center',
});
const TranslitFooterPill = () => {
    const mutxt = (0, context_1.useMuTxt)();
    const activeId = mutxt.translit.active.use();
    if (!activeId)
        return null;
    const scheme = mutxt.translit.schemes.get(activeId);
    if (!scheme)
        return null;
    const short = scheme.short ?? scheme.language.toUpperCase();
    return (React.createElement("span", { className: wrapClass },
        React.createElement(BasicTooltip_1.BasicTooltip, { nowrap: true, "aria-label": `${scheme.name} (click to disable)`, renderTooltip: () => `${scheme.name} (click to disable)`, shortcut: (0, keys_1.formatKeys)(['Primary', 'Alt', 't']) },
            React.createElement(BasicButton_1.default, { width: "auto", compact: true, onClick: (event) => {
                    event.preventDefault();
                    mutxt.translit.off();
                } },
                React.createElement(Iconista_1.Iconista, { set: "fontawesome_regular", icon: "keyboard", width: 16, height: 16 }),
                React.createElement(Space_1.Space, { horizontal: true, size: -3 }),
                short)),
        React.createElement(BasicTooltip_1.BasicTooltip, { nowrap: true, "aria-label": "Show phonetic map", renderTooltip: () => 'Show phonetic map', shortcut: (0, keys_1.formatKeys)(['Primary', 'Alt', 'Shift', 't']) },
            React.createElement(BasicButton_1.default, { onMouseDown: (event) => {
                    event.preventDefault();
                }, onClick: (event) => {
                    event.preventDefault();
                    mutxt.translit.openMap();
                } },
                React.createElement(Iconista_1.Iconista, { set: "tabler", icon: "map", width: 16, height: 16 }))),
        React.createElement(Space_1.Space, { horizontal: true, size: -2 }),
        React.createElement(Separator_1.Separator, { style: { width: 1, height: 48 } })));
};
exports.TranslitFooterPill = TranslitFooterPill;
